module.exports = __webpack_public_path__ + "assets/d947feb2770ea596f2451f5d66ad5af9.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/cz/video.ogv
// module id = 371
// module chunks = 1